import { ACTIVITY_LINK } from "@/constants/scrmtech"

export const FOOTERDATA = [
  {
    title: "关于我们",
    data: [
      { title: "公司概况", path: "/about-us/" },
      { title: "发展历程", path: "/history/" },
      { title: "新闻中心", path: "/company-activity/" },
      {
        title: "市场活动",
        path: ACTIVITY_LINK,
      },
      { title: "加入我们", path: "/join-us" },
      { isEmpty: true },
      { title: "隐私政策", path: "/privacy-policy" },
      { title: "Cookie 政策", path: "/cookie-policy" },
      { title: "安全合规", path: "/law" },
      { title: "版本支持策略", path: "/tidb-release-support-policy" },
      { title: "漏洞管理策略", path: "/addressing-security-vulnerabilities" },
    ],
  },
  {
    title: "资源中心",
    data: [
      { title: "社区", path: "https://tidb.net", isBlank: true },
      {
        title: "TiDB 文档",
        path: "https://docs.pingcap.com/zh/tidb/stable",
        isBlank: true,
      },
      {
        title: "TiDB 6.x in Action",
        path: "https://tidb.net/book/book-rush/",
        isBlank: true,
      },
      {
        title: "快速上手指南",
        path: "https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb",
        isBlank: true,
      },
      { title: "社区问答-AskTUG", path: "https://asktug.com", isBlank: true },
      { title: "博客", path: "/blog", isBlank: true },
      { title: "GitHub", path: "https://github.com/pingcap", isBlank: true },
      { title: "PingCAP Education", path: "/education" },
      { title: "商标下载及使用", path: "/logo-download" },
    ],
  },
  {
    title: "联系我们",
    data: [
      { title: "商务咨询", isSubTitle: true },
      { title: "400-6790-886", path: "tel:+86-400-6790-886" },
      { title: "010-58400041", path: "tel:+86-010-58400041" },
      { title: "info@pingcap.com", path: "mailto:info@pingcap.com" },
      { isEmpty: true },
      { title: "前台总机", isSubTitle: true },
      { title: "010-53326356", path: "tel:+86-010-53326356" },
      { isEmpty: true },
      { title: "媒体合作", isSubTitle: true },
      { title: "pr@pingcap.com", path: "mailto:pr@pingcap.com" },
    ],
  },
]

export const PLATFORMLIST = [
  { path: "https://twitter.com/PingCAP", iconName: "twitter" },
  { path: "https://www.linkedin.com/company/pingcap", iconName: "linkedin" },
  { path: "https://www.reddit.com/r/TiDB", iconName: "reddit" },
  { path: "https://groups.google.com/g/tidb-user?pli=1", iconName: "google" },
  {
    path: "https://stackoverflow.com/questions/tagged/tidb",
    iconName: "stackoverflow",
  },
]

export const FOOTER_COMPANY_DESCRIBE = {
  h4: "PingCAP 公司",
  p:
    "PingCAP 是业界领先的企业级开源分布式数据库企业，提供包括开源分布式数据库产品、解决方案与咨询、技术支持与培训认证服务，致力于为全球行业用户提供稳定高效、安全可靠、开放兼容的新型数据服务平台，解放企业生产力，加速企业数字化转型升级。",
}

export const BEIAN_MIIT_LINK = "https://beian.miit.gov.cn/#/Integrated/index"
export const BEIAN_GOW_LINK =
  "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035112"
